import Vue from 'vue';
import apiClient from '../../apiClient';

export default {
  state: () => ({
    currentTimezone: null,
    timezones: []
  }),

  actions: {
    getTimezonesList: ({ commit }, firmId) => {
      new Promise((resolve, reject) => {
        apiClient
          .get(`/timezones`)
          .then(response => {
            commit('setTimezonesList', response.data.timezones);
            resolve(response);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },

  mutations: {
    setTimezonesList: (state, timezones) => {
      Vue.set(state, 'timezones', timezones);
    }
  }
};
